import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import find from 'lodash.find';
import { slice, sortBy } from 'lodash';
import { setHomeLeagues, setHomeActive, setHomeLeaguesActive, removeHomeActiveLeague, getMarketData, selectHomeActiveLeague, getHomeActiveLeagueEventsDesktop } from '../../store/actions/home.actions';
import { selectSportMobile } from '../../store/actions/todayActions';
import { getStatsData, getBanners } from '../../store/actions/general.actions';
import TopLinks from '../TopLinks';
import TopLeague from '../TopLeague';
import { intervalTime, lSportsConfig, totalSegments } from '../../config';
import Loading from '../../Components/Common/NewLoading';
import { setStatistics } from '../../store/actions/lsports.global.actions';
import Betslip from '../Betslip';
import Upcoming from './index';
import { withRouter } from 'react-router-dom';
// import BannerCarousel from '../Common/Banner/BannerCarousel';
import { staticPrematchSports } from '../../config/sports';
import InnerLinks from '../TopLinks/InnerLinks';
import League from '../Home/League';
import OwlCarousel from 'react-owl-carousel2';
import ImpMatchBanners from '../Common/ImpMatchBanner/BannerCarousel';
import BannerCarousel from '../Common/Banner/BannerCarousel';

let sportEventInterval;
const options = {
    items: 6,
    nav: true,
    dots: true,
    margin:10,
    navText: [
        '<span class=\'nav-btn prev-slide\'><i class="fas fa-chevron-left"></i></span>',
        '<span class=\'nav-btn next-slide\'><i class="fas fa-chevron-right"></i></span>'
    ],  

};
class SportsHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showExtraOddsModal: false,
            event: {},
            showStatisticsModal: false,
        };
    }
    componentDidMount() {
        const { selectSportMobile, selectedLeague } = this.props;
        // this.props.getBanners();
        // let sportsList = Object.values(staticPrematchSports()).filter(sport => sport.k_sport);
        // if (sportsList?.[0]) selectSportMobile(sportsList[0].sport_id);
         if (selectedLeague) {
            this.props.selectHomeActiveLeague(selectedLeague);
            for(let segmentNo = 0; segmentNo < totalSegments; segmentNo ++) {
                this.props.getHomeActiveLeagueEventsDesktop(selectedLeague, segmentNo);
            }  

        }
        // if (!statsData) this.props.getStatsData();
        sportEventInterval = setInterval(() => {
        let { mainEvents } = this.props;
        this.props.getMarketData(mainEvents, 0, mainEvents.length);
        } , intervalTime);

        
    }

    componentDidUpdate(prevProps) {
        if(prevProps.mainEvents !== this.props.mainEvents && this.state.showExtraOddsModal) {
            let fixture = find(this.props.mainEvents, (event) => event.fixture_id === this.props.extraMarketEvent.fixture_id);
            this.props.setCurrentEvent(fixture);
            this.setState({ event: fixture });
        }

        if(prevProps.fetchedAll !== this.props.fetchedAll && this.props.fetchedAll ){
            this.getEventMarkets();            
        }
        if (prevProps.selectedLeague !== this.props.selectedLeague && this.props.selectedLeague) {
            // League data
            const { selectedLeague} = this.props;
            // this.props.selectHomeActiveLeague(selectedLeague);
            for(let segmentNo = 0; segmentNo < totalSegments ; segmentNo ++) {
                this.props.getHomeActiveLeagueEventsDesktop(selectedLeague, segmentNo);
            }  

           // this.props.getHomeActiveLeagueEvents(selectedLeague);
            // if (!statsData) this.props.getStatsData();
            sportEventInterval = setInterval(() => {
            let { mainEvents } = this.props;
            this.props.getMarketData(mainEvents, 0, mainEvents.length);
            } , intervalTime);
        }
    }

    componentWillUnmount() {
       // this.props.selectSport(lSportsConfig.today.selectedSport);
        this.props.setHomeActive(true);
        this.props.setHomeLeaguesActive(false);
        this.props.removeHomeActiveLeague();
        clearInterval(sportEventInterval);
    }

    getEventMarkets = () => {
        const startIndex = this.props.nextIndex || 0;
        const data = slice(this.props.partialAllEvents, 0, 20);
        this.props.getMarketData(data, startIndex, data.length);
    }

    openStatisticsModal = (fixture) => {
        // let statsTemplateType = fixture.has_prematch_statistics ? 'prematch' : fixture.has_live_statistics ? 'live' : '';
        this.setState({ showStatisticsModal: true });
        this.props.setStatistics(fixture.fixture_id, 'forMatch', 'prematch');
    };

    render() {
        let sportsList = Object.values(staticPrematchSports());
        sportsList = sortBy(sportsList, ['sort']);
        const { extraMarketChild: ExtraMarket, isHomeLeagueActive } = this.props;

        return (
            <React.Fragment>
                           
                <div className="middle-part sport-middle d-flex">
                    {!ExtraMarket && <div id='side-navbar' className="side-navbar fade1">
                        <nav className="side-multilevel">
                            {/* <TopLeague /> */}
                            <div id='item-search'/>
                            
                            <div id='location-filter' className='' />
                        </nav>
                    </div>}
                    <div id="scrollableDiv" className={ `odds-panel  ${ExtraMarket ? 'mid-expand' : ''}`}>                   
                            {/* <div className='sports-heading'>
                                <h4>Sports</h4>
                            </div> */}                       
                            <div>
                                {!ExtraMarket && <BannerCarousel />}
                               {!ExtraMarket && 
                               <>
                                {/* <div className='sports-banner-wrap'>
                                    <div className="casino-banner-content text-center">
                                        <h4>USE CODE CASINO</h4>
                                        <h3>EXPERIENCE THE THRILL <br/>
                                            OF A REAL CASINO
                                        </h3>
                                    </div>
                                </div> */}
                                {/* <div className='match-card-wrap d-flex'>
                                    <div className="match-card">
                                        <div className="match-detail-wrap d-flex align-items-center justify-content-between">
                                            <span className="game-name">
                                            <img alt="stream" className="nav-ico-light mr-2" width="20" src="/images/sports/Football-desktop-white.svg" />England</span>
                                            <span>Tomorrow at 00:30</span>
                                        </div>
                                        <div className="team-score-wrap my-4 d-flex">
                                            <div className="team-name  d-flex justify-content-between w-100">
                                                <div className="team-one">
                                                    <div className="flag live-flag-25" country="flag_21"></div>
                                                    <h4>Pakistan</h4>
                                                </div>
                                                <div className="team-second text-right">
                                                    <div className="flag live-flag-25" country="flag_39"></div>
                                                    <h4>Calvin Hemery</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="team-score-wrap d-flex my-3">
                                            <div className="team-score-card mr-3 alerts-border">1.06</div>
                                            <div className=" mr-3 vs-text"><b>VS</b></div>
                                            <div className="team-score-card success-border">3.75</div>
                                        </div>
                                    </div>
                                    <div className="match-card">
                                        <div className="match-detail-wrap d-flex align-items-center justify-content-between">
                                            <span className="game-name">
                                            <img alt="stream" className="nav-ico-light mr-2" width="20" src="/images/sports/Football-desktop-white.svg" />England</span>
                                            <span>Tomorrow at 00:30</span>
                                        </div>
                                        <div className="team-score-wrap my-4 d-flex">
                                            <div className="team-name  d-flex justify-content-between w-100">
                                                <div className="team-one">
                                                    <div className="flag live-flag-25" country="flag_21"></div>
                                                    <h4>Pakistan</h4>
                                                </div>
                                                <div className="team-second text-right">
                                                    <div className="flag live-flag-25" country="flag_39"></div>
                                                    <h4>Calvin Hemery</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="team-score-wrap d-flex my-3">
                                            <div className="team-score-card mr-3 alerts-border">1.06</div>
                                            <div className=" mr-3 vs-text"><b>VS</b></div>
                                            <div className="team-score-card success-border">3.75</div>
                                        </div>
                                    </div>
                                    <div className="match-card">
                                        <div className="match-detail-wrap d-flex align-items-center justify-content-between">
                                            <span className="game-name">
                                            <img alt="stream" className="nav-ico-light mr-2" width="20" src="/images/sports/Football-desktop-white.svg" />England</span>
                                            <span>Tomorrow at 00:30</span>
                                        </div>
                                        <div className="team-score-wrap my-4 d-flex">
                                            <div className="team-name  d-flex justify-content-between w-100">
                                                <div className="team-one">
                                                    <div className="flag live-flag-25" country="flag_21"></div>
                                                    <h4>Pakistan</h4>
                                                </div>
                                                <div className="team-second text-right">
                                                    <div className="flag live-flag-25" country="flag_39"></div>
                                                    <h4>Calvin Hemery</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="team-score-wrap d-flex my-3">
                                            <div className="team-score-card mr-3 alerts-border">1.06</div>
                                            <div className=" mr-3 vs-text"><b>VS</b></div>
                                            <div className="team-score-card success-border">3.75</div>
                                        </div>
                                    </div>
                                    <div className="match-card">
                                        <div className="match-detail-wrap d-flex align-items-center justify-content-between">
                                            <span className="game-name">
                                            <img alt="stream" className="nav-ico-light mr-2" width="20" src="/images/sports/Football-desktop-white.svg" />England</span>
                                            <span>Tomorrow at 00:30</span>
                                        </div>
                                        <div className="team-score-wrap my-4 d-flex">
                                            <div className="team-name  d-flex justify-content-between w-100">
                                                <div className="team-one">
                                                    <div className="flag live-flag-25" country="flag_21"></div>
                                                    <h4>Pakistan</h4>
                                                </div>
                                                <div className="team-second text-right">
                                                    <div className="flag live-flag-25" country="flag_39"></div>
                                                    <h4>Calvin Hemery</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="team-score-wrap d-flex my-3">
                                            <div className="team-score-card mr-3 alerts-border">1.06</div>
                                            <div className=" mr-3 vs-text"><b>VS</b></div>
                                            <div className="team-score-card success-border">3.75</div>
                                        </div>
                                    </div>
                                </div> */}
                                </>
                                }
                                <div className='new-sports-wrap'>
                                    <TopLinks 
                                        sports={ sportsList }
                                    />    
                                </div>
                                </div>
                        { !ExtraMarket ? <ImpMatchBanners />: null}
                        { !ExtraMarket ? <InnerLinks/>: null}
                        {ExtraMarket ? <ExtraMarket match={this.props.match} />:
                        isHomeLeagueActive ? <League /> : <Upcoming noSports={ true } limit={this.props.limit}/>}
                    </div>
                    <Betslip />
                </div>               
            </React.Fragment>  
        )   
        }
}

SportsHome.propTypes = {
    isHomeActive: PropTypes.bool,
    setHomeActive: PropTypes.func,
    setHomeLeaguesActive: PropTypes.func,
    removeHomeActiveLeague: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        selectedLeague: state.home.selectedLeague,
        isHomeActive: state.home.isHomeActive,
        isHomeLeagueActive: state.home.isHomeLeagueActive,
        language: state.general.language,
        statisticsType: state.lsportsGlobal.statisticsType,
        extraMarketEvent: state.lsportsGlobal.extraMarketEvent,
        mainEvents: state.home.mainEvents,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHomeLeagues: () => dispatch(setHomeLeagues()),
        setHomeActive: (value) => dispatch(setHomeActive(value)),
        setHomeLeaguesActive: (value) => dispatch(setHomeLeaguesActive(value)),
        removeHomeActiveLeague: () => dispatch(removeHomeActiveLeague()),
        selectSportMobile: (sportId) => dispatch(selectSportMobile(sportId)),
        getStatsData: () => dispatch(getStatsData()),
        getBanners: () => dispatch(getBanners()),
        setStatistics: (fixtureId, statsType, statsTemplateType) => dispatch(setStatistics(fixtureId, statsType, statsTemplateType)),
        getMarketData: (data, startIndex, count) => dispatch(getMarketData(data, startIndex, count)),
        selectHomeActiveLeague: (leagueId) => dispatch(selectHomeActiveLeague(leagueId)),
        getHomeActiveLeagueEventsDesktop: (leagueId , segmentNo) => dispatch(getHomeActiveLeagueEventsDesktop(leagueId,segmentNo)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SportsHome));

